// StcIntRelocation DTOs for internal relocations and bin placement foundation (Grunnlag)

export interface StcIntRelocationDto {
  id: number;
  companyNo: string;
  warehouseID: string;
  itemNo: string;
  binCode: string;
  quantity: number;
  transType: number;
  grShipmentNo?: number;
  stcBoxNo?: number;
  transDt: string;
  lineStatus: number;
  relID: string;
  operatorID?: string;
  orderNo?: number;
  lineNo?: number;
  batchNo?: string;
  expiryDate?: string;
  itemBarCode?: string;
  binGrpNo?: number;
  serialNo?: string;
  created?: string;
  lastUpdate?: string;
  createdBy?: string;
  updatedBy?: string;

  // Fields from joined tables
  description1?: string;  // From Items table
  lineNoERP?: number;     // From POrderLine table
  orderNoERP?: string;    // From POrderLine table
  stdLocationName?: string; // From POrderLine table - ERP-suggested location for Standard mode

  statusText: string;
  transTypeText: string;
}

export interface StcIntRelocationStatisticsDto {
  totalRelocations: number;
  pendingRelocations: number;
  completedRelocations: number;
  completionPercentage: number;
}

export interface CreateStcIntRelocationRequest {
  warehouseID: string;
  itemNo: string;
  binCode: string;
  quantity: number;
  transType: number;
  grShipmentNo?: number;
  stcBoxNo?: number;
  transDt?: string;
  lineStatus?: number;
  relID?: string;
  operatorID?: string;
  orderNo?: number;
  lineNo?: number;
  batchNo?: string;
  expiryDate?: string;
  itemBarCode?: string;
  binGrpNo?: number;
}

export interface UpdateStcIntRelocationStatusRequest {
  status: number;
}

export interface StcIntRelocationFilterDto {
  warehouseID?: string;
  itemNo?: string;
  binCode?: string;
  transType?: number;
  lineStatus?: number;
  operatorID?: string;
  orderNo?: number;
  batchNo?: string;
  fromDate?: string;
  toDate?: string;
  binGrpNo?: number;
}

// Grunnlag-specific types (extended from StcIntRelocationDto with additional display info)
export interface GrunnlagItemDto extends StcIntRelocationDto {
  itemDescription?: string; // From Items.Description1
  grBatchNo?: string; // From ItemBins.BatchNo (tidligere GRShipment)
  grExpiryDate?: string; // From ItemBins.ExpiryDate (tidligere GRShipment)
}

// Status mapping for display
export const LineStatusMap: Record<number, { text: string; color: string }> = {
  0: { text: 'Ny', color: 'blue' },
  10: { text: 'Tildelt', color: 'yellow' },
  20: { text: 'Under arbeid', color: 'orange' },
  30: { text: 'Pauset', color: 'gray' },
  60: { text: 'Ferdig', color: 'green' },
  100: { text: 'Ferdig', color: 'green' },
  110: { text: 'Avbrutt', color: 'red' }
};

// TransType mapping for display
export const TransTypeMap: Record<number, { text: string; color: string }> = {
  1: { text: 'Utlegg', color: 'blue' },
  2: { text: 'Påfylling', color: 'green' },
  3: { text: 'Optimalisering', color: 'purple' },
  4: { text: 'Flytting', color: 'orange' }
};
